export default "__VITE_ASSET__OZPv$do$__"